import { render, staticRenderFns } from "./CarrotShopPanel.vue?vue&type=template&id=b8e96410&scoped=true"
import script from "./CarrotShopPanel.vue?vue&type=script&lang=js"
export * from "./CarrotShopPanel.vue?vue&type=script&lang=js"
import style0 from "./CarrotShopPanel.vue?vue&type=style&index=0&id=b8e96410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e96410",
  null
  
)

export default component.exports